import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CheckCircle2, Globe, RefreshCw, XCircle } from 'lucide-react';
import { Button } from '../../ui/button';
import { API, auth, err } from '../invoices/invoiceApi';

const when = (iso) => (iso ? new Date(iso).toLocaleString() : '—');

export const PublishReminder = ({ r, token, onData }) => {
  const [busy, setBusy] = useState(false);
  if (!r) return null;
  const ok = r.state === 'verified';
  const recheck = () => {
    setBusy(true);
    axios.post(`${API}/admin/setup-checklist/branding-verify`, {}, auth(token))
      .then((res) => { onData(res.data); toast[res.data.publish_reminder?.reminder ? 'warning' : 'success'](res.data.publish_reminder?.reminder ? 'Published site still differs from Company Profile' : 'Published branding verified'); })
      .catch((e) => toast.error(err(e, 'Could not check the published site'))).finally(() => setBusy(false));
  };
  return (
    <div className={`rounded-lg border p-4 text-sm space-y-2 ${ok ? 'bg-emerald-50 border-emerald-200' : 'bg-amber-50 border-amber-200'}`} data-testid="publish-reminder">
      <div className="flex flex-wrap items-center gap-2">
        <Globe className={`w-4 h-4 ${ok ? 'text-emerald-700' : 'text-amber-700'}`} />
        <p className="font-semibold flex-1" data-testid="publish-reminder-title">{ok ? 'Published branding verified' : 'Republish needed for search & share branding'}</p>
        <Button size="sm" variant="outline" onClick={recheck} disabled={busy} data-testid="publish-reminder-recheck"><RefreshCw className={`w-3.5 h-3.5 mr-1 ${busy ? 'animate-spin' : ''}`} />Check live site now</Button>
      </div>
      <p className="text-neutral-700" data-testid="publish-reminder-detail">{r.detail}</p>
      {r.checks && (
        <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-1" data-testid="publish-reminder-checks">
          {r.checks.map((c) => (
            <li key={c.key} className="flex items-start gap-1.5" data-testid={`publish-check-${c.key}`} title={`Expected: ${c.expected}\nFound: ${c.found ?? 'missing'}`}>
              {c.ok ? <CheckCircle2 className="w-4 h-4 text-emerald-600 mt-0.5 shrink-0" /> : <XCircle className="w-4 h-4 text-amber-600 mt-0.5 shrink-0" />}
              <span>{c.label}{!c.ok && <span className="block text-xs text-neutral-500">Live: {c.found ?? 'missing'}</span>}</span>
            </li>
          ))}
        </ul>
      )}
      <p className="text-xs text-neutral-500" data-testid="publish-reminder-meta">Checked {r.url || ''} at {when(r.checked_at)}{r.verified_at ? ` · last verified ${when(r.verified_at)}` : ' · never verified'}{r.published_build_at ? ` · live build ${when(r.published_build_at)}` : ''}. Re-checks automatically after each publish. Header, footer and emails update instantly; only search and share details need a republish.</p>
    </div>
  );
};
